export enum NotificationDeliverTargetType {
  All = 1,
  Personal = 2,
}
